import { Component } from "preact";
import { connect } from "react-redux";
import { change, formValueSelector, reduxForm } from "redux-form";
import IconArrowDown from "../../assets/images/icon-arrow-down.svg";
import Button from "../../components/Button";
import {
  closeAdditionalQuestions,
  openAdditionalQuestions,
  updateAssignedAdditionalQuestions
} from "../../state/actions/attendeeProfileActions";
import { scrollToErrors } from "../../utils/ScrollToErrors";
import TicketsQuestions from "../details/TicketsQuestions";
import { getTicketValues } from "../../utils/stateConstructors";

const getTicketQuestions = (ticketTypeId, additionalQuestions) => {
  return additionalQuestions.filter(question => {
    if (question.perOrder || question.disabled || question.deleted) {
      return false;
    }
    if (
      question.appliesTo &&
      question.appliesTo.length &&
      question.appliesTo.indexOf(ticketTypeId) === -1
    ) {
      return false;
    }
    return question;
  });
};

class AdditionalQuestions extends Component {
  saveAdditionalQuestions = ({ tickets }) => {
    const { updateAssignedAdditionalQuestions, ticketId } = this.props;
    updateAssignedAdditionalQuestions(ticketId, tickets[ticketId]);
  };

  render({
    order,
    event,
    ticketsAdditionalQuestions,
    buyerData,
    dispatch,
    ticketId,
    handleSubmit,
    form,
    attendeeProfile,
    openAdditionalQuestions,
    closeAdditionalQuestions,
    token
  }) {
    const { additionalQuestionDefault } = attendeeProfile;
    const { loading, open } = additionalQuestionDefault[ticketId] || {
      open: true
    };
    const ticket = order.data.tickets.find(t => t._id === ticketId);
    const changeFieldValue = (field, value) => {
      dispatch(change(form, field, value));
    };
    let detailsAdditionQuestions =
      event.data.additionalQuestions && event.data.additionalQuestions.length
        ? event.data.additionalQuestions.filter(q => {
            const checkIgnore = (type, question) =>
              q.type == type && q.question === question;
            const shouldBeIgnored =
              checkIgnore("firstName", "First Name") ||
              checkIgnore("lastName", "Last Name") ||
              checkIgnore("email", "Email");
            return (!q.askAfterCheckout || token) && !shouldBeIgnored;
          })
        : [];
    detailsAdditionQuestions = detailsAdditionQuestions.map(q => {
      if (q.type === "multiSelect" && q.options && q.options.length) {
        q.options = q.options.map(o => {
          const newOption = o.label
            ? {
                ...o
              }
            : {
                ...o,
                id: o._id,
                label: o.value,
                value: false
              };
          return newOption;
        });
      }
      return q;
    });
    const numberOfQuestions = getTicketQuestions(
      ticket.ticketTypeId,
      detailsAdditionQuestions
    ).length;
    if (numberOfQuestions === 0) {
      return null;
    }
    const openAction = open
      ? closeAdditionalQuestions
      : openAdditionalQuestions;
    return (
      <form
        onSubmit={handleSubmit(this.saveAdditionalQuestions)}
        style={{
          backgroundColor: "#f9f9fa",
          width: "100%",
          padding: "12px 12px 8px 12px"
        }}
      >
        <div
          onClick={() => openAction(ticketId)}
          style={{ width: "100%", display: "flex", cursor: "pointer" }}
        >
          <h3
            style={{ marginBottom: 2, flexGrow: 1 }}
          >{`Additional Questions (${numberOfQuestions})`}</h3>
          <img
            src={IconArrowDown}
            style={{
              width: 16,
              height: 24,
              marginRight: 16,
              transform: `rotate(${open ? 180 : 0}deg)`
            }}
          />
        </div>
        {open ? (
          <div>
            {loading ? (
              <div
                class="loading loading-lg"
                style={{ padding: "0 0 10px 0", marginRight: 10 }}
              />
            ) : (
              <div>
                <TicketsQuestions
                  tickets={[ticket]}
                  ticketTypes={event.data.ticketTypes}
                  ticketsAdditionalQuestions={ticketsAdditionalQuestions}
                  additionalQuestions={detailsAdditionQuestions}
                  buyerData={buyerData}
                  changeFieldValue={changeFieldValue}
                  sameAsBuyerChecks={false}
                  hideTitles={true}
                  formName={form}
                />
                <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                  <Button buttonType="submit" type={"primary"}>
                    Save
                  </Button>
                </div>
              </div>
            )}
          </div>
        ) : null}
      </form>
    );
  }
}

AdditionalQuestions = reduxForm({
  destroyOnUnmount: true,
  enableReinitialize: true,
  onSubmitFail: errors => {
    scrollToErrors();
  }
})(AdditionalQuestions);

AdditionalQuestions = connect((state, ownProps) => {
  const tickets = getTicketValues(
    state.order.data,
    state.event.data.additionalQuestions,
    false
  );
  return {
    initialValues: {
      tickets: tickets
    }
  };
})(AdditionalQuestions);

AdditionalQuestions = connect(
  (state, ownProps) => {
    const { form } = ownProps;
    const selector = formValueSelector(form);
    return {
      event: state.event,
      order: state.order,
      seatingMap: state.seatingMap,
      attendeeProfile: state.attendeeProfile,
      buyerData: {
        firstName: state.order.data.firstName,
        lastName: state.order.data.lastName,
        mobile: state.order.data.mobile,
        email: state.order.data.email
      },
      ticketsAdditionalQuestions: selector(state, "tickets")
    };
  },
  {
    updateAssignedAdditionalQuestions,
    openAdditionalQuestions,
    closeAdditionalQuestions
  }
)(AdditionalQuestions);

export default AdditionalQuestions;



// WEBPACK FOOTER //
// ./routes/conferences/AdditionalQuestions.js